// src/cameraManager.js

// Esta variável 'stream' é privada para este módulo. Só pode ser acessada pelas funções abaixo.
let stream = null;

const cameraManager = {
  /**
   * Inicia a câmera. Garante que qualquer stream anterior seja parada.
   * @param {HTMLVideoElement} videoElement - O elemento de vídeo onde a imagem será exibida.
   * @returns {boolean} - Retorna true se a câmera foi iniciada com sucesso, false caso contrário.
   */
  start: async (videoElement) => {
    // Garante que qualquer câmera rodando seja parada antes de iniciar uma nova.
    cameraManager.stop();
    
    try {
      console.log("[Manager] Solicitando acesso à câmera.");
      stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
      
      if (videoElement) {
        videoElement.srcObject = stream;
      }
      return true; // Sucesso
    } catch (err) {
      console.error("[Manager] Falha ao iniciar a câmera:", err);
      stream = null; // Garante que a referência esteja limpa em caso de erro.
      return false; // Falha
    }
  },

    stop: () => {
        if (stream) {
            console.log("[Manager] Comando para PARAR a câmera recebido.");
            stream.getTracks().forEach(track => track.stop());
            stream = null;
            console.log("[Manager] Câmera parada com sucesso.");
        } else {
            console.log("[Manager] Tentativa de parar a câmera, mas não há stream ativo.");
        }
    },
};

// Exportamos o objeto como o padrão para que possamos importá-lo em outros arquivos.
export default cameraManager;